import { DropdownWithSearch } from "InnoUI/innoinput";
import { folderOrder } from "utils/optionData/utils";

const FolderIOrderDropdown = ({
  onChange = () => {},
  defaultValue,
  disabled = true,
  name,
}) => {
  const projectOptions = folderOrder.map((data) => ({
    id: data.id,
    label: data.order,
  }));

  const handleDropdownChange = (value) => {
    const selectedOption = projectOptions.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      placeholder="Select Type "
      options={projectOptions}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={disabled}
      width="90%"
      dropdowType={name}
    />
  );
};

export default FolderIOrderDropdown;
